import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLoginMutation } from '@/store/api/authApi';
import { useAppDispatch } from '@/hooks/redux';
import { setTempAuthToken, setToken } from '@/store/slices/authSlice';
import toast from 'react-hot-toast';
import { LoginFormData, loginSchema } from '@/utils/validations';
import CustomInput from '@/components/common/CustomInput';
import CaptchaBox from '@/components/common/CaptchaBox';

function LoginPage() {
  const [captchaId, setCaptchaId] = useState('');
  const [refreshKey, setRefreshKey] = useState(0);
  const [login, { isLoading, error }] = useLoginMutation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { control, handleSubmit, reset } = useForm<LoginFormData>({
    resolver: zodResolver(loginSchema),
  });

  const onSubmit = async (data: LoginFormData) => {
    try {
      const payload = {
        username: data.email,
        password: data.password,
      };
      const res = await login(payload).unwrap();
      if (res?.accessToken) {
        dispatch(setToken(res.accessToken));
        reset();
        navigate('/', { replace: true });
      }
    } catch (err: any) {
      console.error('Login failed:', err);
      toast.error(err?.data?.message || 'Login failed!');
    } finally {
      setRefreshKey((prev) => prev + 1);
    }
  };
  return (
    <div className="mx-auto ">
      <div className="flex flex-col gap-y-2 sm:bg-gray-500/10 p-4 rounded-lg w-full max-w-[500px] border border-white">
        <img src={`/images/logo.png`} alt="" className="max-w-[120px] self-center" />
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-3">
          {/* Username */}
          <CustomInput
            name="email"
            type="email"
            control={control}
            label="Email*"
            placeholder="abc@shiv247.com"
            autoComplete="email"
          />

          {/* Password */}
          <CustomInput
            name="password"
            control={control}
            label="Password*"
            type="password"
            placeholder="Enter your password"
            autoComplete="current-password"
            inputRules={{
              noSpace: true,
              maxLength: 20,
            }}
          />

          <div className="mt-3 w-full flex justify-center">
            <button
              type="submit"
              className="w-full px-2 py-2 bg-primary rounded-md text-base flex justify-center items-center"
              disabled={isLoading}
            >
              {isLoading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : 'LOGIN'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
export default LoginPage;
